module.exports = __webpack_public_path__ + "img/icon-contact-black.10617e74.svg";